import { ArrowDownIcon, ArrowUpIcon } from '@orn/shared-web/icons';
import { cx } from '@orn/shared-web/utils/cx';

import { calculateChange } from '../../../utils/changeCalculations';
import { toCurrency } from '../../../utils/formatting';

export interface IChangeIndicatorProps {
  current?: number;
  previous?: number;
  versusText?: string;
  increaseGood?: boolean;
  className?: string;
}

const ChangeIndicator = ({ current, previous, versusText, increaseGood = false, className }: IChangeIndicatorProps) => {
  // Return null if either value is undefined
  if (current === undefined || !previous) {
    return null;
  }

  const { difference, percentage, isGoodChange, isIncrease, isZeroChange } = calculateChange({
    current,
    previous,
    increaseGood,
  });
  const formattedDifference = toCurrency(Math.abs(difference));

  return (
    <div className={cx('flex items-center gap-1', className)}>
      {!isZeroChange &&
        (isIncrease ? (
          <ArrowUpIcon className={cx('size-4', isGoodChange ? 'text-success-primary' : 'text-error-primary')} />
        ) : (
          <ArrowDownIcon className={cx('size-4', isGoodChange ? 'text-success-primary' : 'text-error-primary')} />
        ))}
      <div className={cx('text-sm font-medium', isGoodChange ? 'text-success-primary' : 'text-error-primary')}>
        {formattedDifference}
        {percentage && ` (${percentage})`}
      </div>
      {versusText && <div className="text-tertiary text-xs font-medium">{versusText}</div>}
    </div>
  );
};

export default ChangeIndicator;
